<template>
  <div id="statistic">
    <div class="mar-b-10">
      <site-search-group v-model.trim="params.keyword"
                         placeholder="Search by email, name, keywords"
                         @search="getList()"
                         @clear="handleClear" />
    </div>
    <div class="filter-items mar-b-30">
      <span class="line-h-40 ipub-p2 fw-bd">Country / Territory</span>
      <ipub-select search
                   style="width:360px"
                   :clear="true"
                   @change="getList()"
                   @search="countrySearch"
                   class="mar-l-12"
                   placeholder="Select country / territory"
                   v-model="params.countryCode">
        <ipub-select-option v-for="item in countryList"
                            :value="item.code"
                            :key="'countryList'+item.code">
          {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
        </ipub-select-option>
      </ipub-select>

      <span class="line-h-40 ipub-p2 fw-bd mar-l-30">Journal</span>
      <ipub-select v-model="params.journalId"
                   style="width:360px"
                   :clear="true"
                   placeholder="Select Journal"
                   class="mar-l-12"
                   @change="getList()"
                   :options="journalList" />

    </div>

    <div>
      <div class="flex ipub-p1 mar-b-10 relative">
        <div class="line-h-40">
          Data update time: {{$moment(staticTime).format('HH : mm DD / MM / YYYY')}}
          <ipub-radio class="mar-l-20 ipub-p2"
                      :checked="params.ipublishmentData"
                      @change="params.ipublishmentData=!params.ipublishmentData;getList()">
            <span>iPublishment Data Included</span>
          </ipub-radio>
        </div>
        <div class="right-option">
          <ipub-button v-show="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.REVIEWERS_STATISTICS.EXPORT')"
                       type="primary"
                       :loading="loading"
                       @click="exp">Export</ipub-button>
        </div>
      </div>
      <ipub-table :columns="columns"
                  fixed
                  @order="onOrderChanage"
                  :pagination="pagination"
                  :dataSource="dataSource">
        <template v-slot:country="{text}">
          <span>{{text?country[text]:'- -'}}</span>
        </template>
        <template v-slot:invitedTime="{text}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft">
            <div slot="title">
              <template v-if="text && text.includes(';')">
                <div v-for="(item,index) in text.split(';')"
                     :key="index">
                  {{item}}
                </div>
              </template>
              <font v-else>{{text || '- -'}}</font>
            </div>
            <div class="omis ipub-c-p">
              {{text}}
            </div>
          </ipub-tooltip>
        </template>
        <template v-slot:journalNameList="{text}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft">
            <div slot="title">
              <template v-if="text">
                <div>{{text.join(";")}}</div>
              </template>
              <font v-else>{{text || '- -'}}</font>
            </div>
            <div class="omis ipub-c-p">
              {{text?text.join(";"):'- -'}}
            </div>
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
